import { formatPrice } from "@/utils/currency";
import { BellRing, X } from "lucide-react";
import { useTranslation } from "react-i18next";

export function NewOrderAlert({ alert, onDismiss, onView }) {
  const { t } = useTranslation();
  if (!alert) return null;

  return (
    <div className="bg-red-600 animate-pulse shadow-lg z-30 relative" data-testid="new-order-alert">
      <div className="px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center animate-bounce">
            <BellRing className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="text-white font-black text-base tracking-wide">{t("notifications.newOrder").toUpperCase()}</p>
            <p className="text-red-100 text-xs">
              #{alert.number} - {alert.customer} - {alert.items} {t("admin.items")} - {formatPrice(alert.total || 0)}
              {alert.source && <span className="ml-1 opacity-75">({alert.source})</span>}
            </p>
          </div>
        </div>
        <button
          onClick={onView}
          className="bg-white text-red-600 font-bold px-4 py-2 rounded-lg text-sm hover:bg-red-50 transition flex items-center gap-2"
          data-testid="dismiss-alert-btn"
        >
          {t("common.view").toUpperCase()} <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
